import type { IScheduledContent } from "@/types/contentCalendar";

export function useNewScheduledContentMutation() {
  const queryClient = useQueryClient();
  const query = useMutation({
    mutationFn: async (body: IScheduledContent) => {
      const response = await usePutRequest<IScheduledContent>("/tasks", body);
      return response.data || null;
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ["scheduled-content"] });
    },
  });

  return query;
}
